// 登记注册

import React from 'react';
import Widget from '../../widget/Widget';
import WidgetAjax from '../../widget/WidgetAjax';
import Cache from '../../frame/Cache';
import Config from '../../config/Config';
import WidgetInterfaceTable from '../../widget/WidgetInterfaceTable';

import '../../css/analysis.css';
import WidgetTable from '../../widget/WidgetTable';
import { Space, Table, Tag } from 'antd';

class Registration extends React.Component 
{   
    constructor()
    {
        super();

        let url = Config.getHermesPanoramaURL();
        let UID = Config.getHermesPanoramaUID();
        
        let entname = Widget.getSessionStorage("entname");
        let basePath = Config.getBasePath();


        this.state = {
            url : url,
            nbUrl:basePath+'/entity/soc_secs',
            basePath:basePath,
            loading:true,
            headerTop: null, // header到顶部的距离
            headerHeight: null, // header的高度
            consTops: [], 
            curIndex:'',
            navList: [
                {
                  id: 'ckjz',
                  text: '存款价值'
                },
                {
                  id: 'jbxx',
                  text: '基本信息'
                },
                {
                  id: 'gdjczxx',
                  text: '股东及出资信息'
                },
                {
                    id: 'zyglry',
                    text: '主要管理人员'
                },
                {
                    id: 'gsbg',
                    text: '工商变更'
                },
              ],
            baseInfo : {
                ENTNAME : "",
                NAME : "",
                UNISCID : "",
                REGCAP : "",
                ENTTYPE : "",
                REGSTATE : "",
                INDUSTRYPHY : "",
                INDUSTRYCO : "",
                ESTDATE : "",
                APPRDATE : "",
                DOM : "",
                REGORG : "",
                OPSCOPE : ""
            },
            ckPoint:'',
            nsValue:'',
            nbcolumns:[
                {name:'INV', title:'年报年度', type:'string'},
                {name:'so110', title:'城镇职工基本养老保险参保人数', type:'string'},
                {name:'so210', title:'失业保险参保人数', type:'string'},
                {name:'so310', title:'职工基本医疗保险参保人数', type:'string'},
                {name:'so410', title:'工伤保险参保人数', type:'string'},
                {name:'so510', title:'生育保险参保人数', type:'string'},
                // {name:'totalpaymentso110', title:'城镇职工基本养老保险缴费基数', type:'string'},
                // {name:'totalpaymentso210', title:'失业保险本期实际缴费金额', type:'string'},
                // {name:'totalpaymentso310', title:'职工基本医疗保险本期实际缴费金额', type:'string'},
                // {name:'totalpaymentso410', title:'工伤保险本期实际缴费金额', type:'string'},
                // {name:'totalpaymentso510', title:'生育保险本期实际缴费金额', type:'string'},
                // {name:'totalwagesso110', title:'参加城镇职工基本养老保险缴费基数', type:'string'},
                // {name:'totalwagesso210', title:'单位参加失业保险缴费基数', type:'string'},
                // {name:'totalwagesso310', title:'单位参加职工基本医疗保险缴费基数', type:'string'},
                // {name:'totalwagesso410', title:'单位参加工伤保险缴费基数', type:'string'},
                // {name:'totalwagesso510', title:'单位参加生育保险缴费基数', type:'string'},
                // {name:'unpaidsocialinsso110', title:'单位参加城镇职工基本养老保险累计欠缴金额', type:'string'},
                // {name:'unpaidsocialinsso210', title:'单位参加失业保险累计欠缴金额', type:'string'},
                // {name:'unpaidsocialinsso310 ', title:'单位参加职工基本医疗保险累计欠缴金额', type:'string'},
                // {name:'unpaidsocialinsso410 ', title:'参加工伤保险累计欠缴金额', type:'string'},
                // {name:'unpaidsocialinsso510 ', title:'单位参加生育保险累计欠缴金额', type:'string'},
            ],
            nbdata:[],
            params :{
                'user':UID,
                'ENTNAME' : entname
            },
            column1:[
                {name:'INV', title:'股东名称', type:'string'},
                {name:'INVTYPE', title:'股东类型', type:'string'},
                {name:'SUBCONAM', title:'认缴出资额', type:'string'},
                {name:'SUBCONPROP', title:'认缴出资比例', type:'string'},
                // {name:'SUBCONCUR', title:'认缴出资币种', type:'string'},
                // {name:'SUBCONFORM', title:'认缴出资方式', type:'string'},
                // {name:'SUBCONDATE', title:'认缴出资日期', type:'string'},
                // {name:'COUNTRY', title:'国别', type:'string'}
            ],
            column2:[
                {name:"NAME",title:"姓名", type:"string"},
                {name:"POSITION",title:"职务", type:"string"},
                {name:"LEREPSIGN",title:"是否法定代表人", type:"string"}
            ],
            column3:[
                {name:"ALTDATE", title:"变更时间", type:"string"},
                {name:"ALTITEM", title:"变更事项", type:"string"},
                {name:"ALTBE", title:"变更前内容", type:"string"},
                {name:"ALTAF", title:"变更后内容", type:"string"},
            ],
            activeType: 1,
            column4:[
                {name:"bank", title:"银行名称", type:"string"},
                {name:"count", title:"交易笔数", type:"string"}
            ],
            column5:[
                {name:"bank", title:"银行名称", type:"string"},
                {name:"money", title:"交易金额(万)", type:"string"}
            ],
            assetEvalInfo:{},
            data:[
                {name: '中国建设银行', num: '500-1000'},
                {name: '中国招商银行', num: '800-1000'},
            ],
            data1:[
                {name: '中国建设银行', num: '500-1000'},
                {name: '中国招商银行', num: '800-1000'},
            ],
        };

        this.onLoadBaseInfo = this.onLoadBaseInfo.bind(this);

        this.onLoadToken = this.onLoadToken.bind(this);

        this.getAssetEvalInfo = this.getAssetEvalInfo.bind(this);
        this.onGetAssetEvalInfo = this.onGetAssetEvalInfo.bind(this);

        this.getEntityBankRelationship = this.getEntityBankRelationship.bind(this);
        this.onGetEntityBankRelationship = this.onGetEntityBankRelationship.bind(this);
        
        Config.getHermesAccess( this.onLoadToken );
    };

    componentDidUpdate( )
    {
        let entname = Widget.getSessionStorage("entname");

        let { params } = this.state;

        if( params.ENTNAME!==entname )
        {
            this.state["params"]["ENTNAME"] = entname;
            Config.getHermesAccess( this.onLoadToken );
        }  

        let headerTopNew = this.header.offsetTop;
        let headerHeightNew =  this.header.clientHeight;
        let consTopsNew = [...this.main.children].map(item => item.offsetTop);
        if (this.state.consTops.length === 0)
        {
            this.setState({
                headerTop:headerTopNew,  
                headerHeight:headerHeightNew,
                consTops:consTopsNew
            });
        }
    }

    
    componentWillReceiveProps(nextprops) {
        let overviewWhiteHeight = document.querySelector('.overview.white').clientHeight
        let tabStyleClass = document.querySelector('.tab.tabStyleClass').clientHeight
        let curIndex = this.state.curIndex;
        const {navList} = this.state

        // tabStyleClass.scrollTop + tabStyleClass.clientHeight >= tabStyleClass.scrollHeight


            this.state.consTops.forEach((top, index) => 
            {
                if (nextprops.scrollTop >= top-this.state.headerHeight - overviewWhiteHeight - tabStyleClass) 
                {
                    curIndex = index;
                }
                else if(nextprops.scrollTop === 0)
                {
                    curIndex = 0;
                }
                else if(nextprops.scrollTop + nextprops.clientHeight >= nextprops.scrollHeight )
                {
                    curIndex = navList.length-1;
                }
            })

            this.setState({ curIndex });
    }


    getCkjz(){
        let { basePath, params} = this.state;
        let data = {
            ENTNAME:params.ENTNAME
        }
        WidgetAjax.ajax({url:basePath + '/entity/info', params:data, callback:(result)=>{
            this.setState({
                ckPoint:result.result.SCORES
            })
        }}); 
    }

    getNspj(){
        let { basePath, params} = this.state;
        let data = {
            ENTNAME:params.ENTNAME
        }
        WidgetAjax.ajax({url:basePath + '/entity/tax_eval', params:data, callback:(result)=>{
            this.setState({
                nsValue:result.result.EVALS?result.results[0].EVALS:[]
            })
        }}); 
    }

    
    getNb(){
        let { basePath, params} = this.state;
        let data = {
            ENTNAME:params.ENTNAME
        }
        WidgetAjax.ajax({url:basePath + '/entity/soc_secs', params:data, callback:(result)=>{
            this.setState({
                nbdata:result.results[0].yearReportSocSecs?result.results[0].yearReportSocSecs:[]
            })
        }}); 
    }
    
    
    change(item)
    {
        
        for( let i=0; i<item.target.parentNode.childNodes.length; i++ )
        {
            item.target.parentNode.childNodes[i].className = "title-label";
        }

        item.target.className = 'title-label title-label-active';

        let id = item.target.id.split("_")[0];
        let e = document.getElementById(id);
        e.scrollIntoView({behavior:'smooth'}); 

    }

    /**
     * 获取 token 回调函数
     * @param {*} result 
     * @returns 
     */
    onLoadToken( result )
    {
        const { url } = this.state;
        
        let { params } = this.state;
         
        if( result.status===0 )
        {
            params["access"] =  result.result.token;
 
            WidgetAjax.ajax({url : url, params : {...params, ...{"service":"getBaseInfo"}}, callback : this.onLoadBaseInfo, backParam:{params:{}} });

            this.setState({ loading: true, params:params});

            this.getAssetEvalInfo(params);

            this.getCkjz()

            this.getNspj()

            this.getNb()

            this.getEntityBankRelationship(params);
        }
        else
        {
            return ;
        }  
    }

    onLoadBaseInfo( result, params )
    { 
        if( result.status===0 && result.result!==undefined )
        {
            this.setState({baseInfo:result.result,loading:false});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
        
    }

    getAssetEvalInfo( params )
    {
        const { basePath } = this.state;
        
        params = {...params, ...{"service":"getAssetEvalInfo"}};

        WidgetAjax.ajax({url :  basePath + "/entity/portrait", params : params, callback : this.onGetAssetEvalInfo, backParam:{params:params} });
    }

    onGetAssetEvalInfo(result, params )
    {
        if( result.status===0 && result.result!==undefined )
        {
            this.setState({assetEvalInfo:result.result,loading:false});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }


    getEntityBankRelationship( params )
    {
        const { basePath } = this.state;
        
        params = {...params};

        WidgetAjax.ajax({url :  basePath + "/entity/bank_relationship", params : params, callback : this.onGetEntityBankRelationship, backParam:{params:params} });
    }

    onGetEntityBankRelationship(result, params )
    {
        if( result.status===0 && result.result!==undefined )
        {
            const data = result.result;

            let data1 = [], data2 = [], data3 = [], data4=[];

            if( data.EXPENDITURE!==undefined )
            {
                data3 = data.EXPENDITURE.countData ? data.EXPENDITURE.countData : [];
                data4 = data.EXPENDITURE.moneyData ? data.EXPENDITURE.moneyData : [];
            }

            if( data.DEPOSIT!==undefined )
            {
                data1 = data.DEPOSIT.countData ? data.DEPOSIT.countData : [];
                data2 = data.DEPOSIT.moneyData ? data.DEPOSIT.moneyData : [];
            }

            this.setState({data1:data1,data2:data2, data3:data3, data4:data4});
        }
        else if (result.status === 10) 
        {
            Cache.logout(this.props);
        }
    }

    rowClassName(record, index){
        console.log(record,index)
        // let className = index % 2 ? 'shallow_gray': 'deep_gray';

        // return className
    }

    changeTab(e , id, index) 
    {
        // 点击导航跳转获取对应的位置，滚动位置
        let overviewWhiteHeight = document.querySelector('.overview.white').clientHeight
        let tabStyleClass = document.querySelector('.tab.tabStyleClass').clientHeight
        document.getElementById('entityDetailPage').scrollTop=this.state.consTops[index] - this.state.headerHeight - tabStyleClass - overviewWhiteHeight
        console.log(this.state.consTops[index] - this.state.headerHeight - tabStyleClass - overviewWhiteHeight)
        this.setState({
            curIndex: index,
            contentType: id+'_id'
        });
    }

    Router

    render()
    {
        const {baseInfo, url, params, column1, column2, column3,loading, assetEvalInfo, activeType, column4, column5, data1, data2, data3, data4,ckPoint,nsValue,nbcolumns
            ,nbdata,nbUrl,navList, curIndex} = this.state;

        return(
            <div className="page">
                <div className="nav-height" ref={el => this.header = el}>
                    <div className="page-weidu entity-title"  style={this.props.headersHeight>0?{width:"936px",position:"fixed",zIndex:"100",marginTop:"6px",borderTop:"1px solid",borderRadius:"0"}:{position:"none"}}>
                      {navList.map((item, index) => (
                        <div
                          id={item.id}
                          className={['title-label', curIndex === index ? 'title-label title-label-active' : ''].join('')}
                          onClick={(e)=>this.changeTab(e, item.id , index)}
                        >{item.text}</div>
                      ))}
                    </div>
                </div>
                {/* <div className="page-weidu entity-title">
                    <div id="baseInfo_flag" className="title-label title-label-active" onClick={this.change.bind(this)}>基本信息</div>
                    <div id="investorInfo_flag" className="title-label " onClick={this.change.bind(this)}>股东及出资信息</div>
                    <div id="managerInfo_flag" className="title-label " onClick={this.change.bind(this)}>主要管理人员</div>
                    <div id="alterInfo_flag" className="title-label " onClick={this.change.bind(this)}>工商变更</div>
                </div> */}
                <div className="page-content page-overflow entity-content white padding-20" ref={el => this.main = el} style={{display:"table"}}>
                    <div className="content-top">
                        <div id="ckjz_id" className="entity-baseInfo">
                            <div className="content-title">
                                <div className="img">
                                    <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                                </div>
                                <div className="font">
                                    <span>存款价值</span>
                                </div>
                            </div>
                            <div style={{textAlign:'left',paddingLeft:'20px'}}>
                                <div style={{marginTop:'6px'}}>
                                    <img src={require("../../img/WechatIMG438.png")} style={{width: '20px',transform: 'rotate(90deg)'}}></img>
                                    <span style={{fontSize:'14px'}}><b>获客推荐总分：</b></span>
                                    <span style={{fontSize:'20px',paddingLeft:'15px',color:ckPoint?
                                            parseInt(ckPoint)<=516?'red':
                                            parseInt(ckPoint)>=517&&parseInt(ckPoint)<=688?'#f38e2d':
                                            parseInt(ckPoint)>=689?'green':'red'
                                            :'red'}}>
                                        {
                                        ckPoint?
                                            parseInt(ckPoint)<=516?'不推荐':
                                            parseInt(ckPoint)>=517&&parseInt(ckPoint)<=688?'较为推荐':
                                            parseInt(ckPoint)>=689?'极为推荐':'不推荐'
                                            :'不推荐'
                                        }
                                    </span>
                                </div>
                                <div style={{marginTop:'16px'}}>
                                    <p style={{fontSize:'14px',width:'180px'}}>
                                    <img src={require("../../img/WechatIMG438.png")} style={{width: '20px',transform: 'rotate(90deg)'}}></img>
                                        <b>推荐总分说明：</b></p>
                                    <p style={{fontSize:'14px',color:'#666',marginTop:'15px',paddingLeft:'27px'}}>推荐度用于表征基于企业自身所处行业、市场地位、成长能力、注册资本、实缴资本、就业人数数据所体现出的企业综合评价存款潜力（60分以下不推荐；61-80分较推荐；81-100分极为推荐）</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="content-top">
                        <div id="jbxx_id" className="entity-baseInfo">
                            <div className="content-title">
                                <div className="img">
                                    <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                                </div>
                                <div className="font">
                                    <span>基本信息</span>
                                </div>
                            </div>
                            <div className="baseInfo">
                                <>{loading?<p className="registration-loading"><img src={require('../../img/frame/loading.gif')} className="loading-registration" alt="es-lint want to get"/></p>:
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td >企业名称</td>
                                                <td>{baseInfo.ENTNAME}</td>
                                                <td >法定代表人</td>
                                                <td>{baseInfo.NAME}</td>
                                                {/* <td >曾用名</td>
                                                <td>{baseInfo.HISENTNAME}</td> */}
                                            </tr>
                                            <tr>
                                                {/* <td >企业英文名称</td> */}
                                                {/* <td>{baseInfo.ENGENTNAME} */}
                                                {/* </td> */}
                                                <td >注册资本（万元）</td>
                                                <td>{baseInfo.REGCAP}</td>
                                                <td >企业类型</td>
                                                <td>{baseInfo.ENTTYPE}</td>
                                            </tr>
                                            <tr>
                                                <td >登记状态</td>
                                                <td>{baseInfo.REGSTATE}</td>
                                                <td >行业门类</td>
                                                <td>{baseInfo.INDUSTRYPHY}</td>
                                            </tr>
                                            {/* <tr>
                                                <td >注册资本币种</td>
                                                <td>{baseInfo.REGCAPCUR}</td>
                                            </tr> */}
                                            <tr>
                                                <td >成立日期</td>
                                                <td>{baseInfo.ESTDATE}</td>
                                                <td >核准日期</td>
                                                <td>{baseInfo.APPRDATE}</td>
                                            </tr>
                                            <tr>
                                                <td >住所</td>
                                                <td>{baseInfo.DOM}</td>
                                                <td >登记机关</td>
                                                <td>{baseInfo.REGORG}</td>
                                            </tr>
                                            {/* <tr>
                                                <td >许可经营项目</td>
                                                <td>{baseInfo.ABUITEM}</td>
                                                <td >从业人数</td>
                                                <td>{baseInfo.EMPNUM}</td>
                                            </tr> */}
                                            <tr>
                                                <td >经营(驻在)期限自</td>
                                                <td>{baseInfo.OPFROM}</td>
                                                <td >经营(驻在)期限至</td>
                                                <td>{baseInfo.OPTO}</td>
                                            </tr>
                                            {/* <tr>
                                                <td >实收资本（万元）</td>
                                                <td>{baseInfo.RECCAP}</td>
                                                <td >归属省份</td>
                                                <td>{baseInfo.PROVINCE}</td>
                                            </tr>
                                            <tr>
                                                <td >归属城市</td>
                                                <td>{baseInfo.CITY}</td>
                                                <td >归属区县</td>
                                                <td>{baseInfo.COUNTY}</td>
                                            </tr> */}
                                            {/* <tr>
                                                <td >邮箱</td>
                                                <td>{baseInfo.EMAIL}</td>
                                                <td >联系人电话</td>
                                                <td>{baseInfo.TEL}</td>
                                            </tr> */}
                                            <tr>
                                                <td >经营范围</td><td colSpan="3" >{baseInfo.OPSCOPE}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                }</>
                            </div>
                        </div>
                    </div>
                    {/* <div className="content-top taking" style={{padding: '0 20px',zIndex:'10',position:'relative'}}>
                        <div className="content-title">
                            <div className="img">
                                <img src={require("../../img/riskCompass/bt_left.svg")} alt="es-lint want to get"></img>
                            </div>
                            <div className="font">
                                <span>营业收入级别</span>
                            </div>
                            <span className='desc_icon'>?</span>
                            <div className='desc_wrap'>
                                <p><span>&gt;=150000</span><span>一级一等</span></p>
                                <p><span>[80000,150000)</span><span>一级二等</span></p>
                                <p><span>[50000,80000)</span><span>一级三等</span></p>
                                <p><span>[30000,50000)</span><span>二级一等</span></p>
                                <p><span>[15000,30000)</span><span>二级二等</span></p>
                                <p><span>[10000,15000)</span><span>二级三等</span></p>
                                <p><span>[8000,10000)</span><span>三级一等</span></p>
                                <p><span>[6000,8000)</span><span>三级二等</span></p>
                                <p><span>[4000,6000)</span><span>三级三等</span></p>
                                <p><span>[2000,4000)</span><span>四级一等</span></p>
                                <p><span>[1000,2000)</span><span>四级二等</span></p>
                                <p><span>[500,1000)</span><span>四级三等</span></p>
                                <p><span>[300,500)</span><span>五级一等</span></p>
                                <p><span>[200,300)</span><span>五级二等</span></p>
                                <p><span>[100,200)</span><span>五级三等</span></p>
                                <p><span>[50,100)</span><span>六级一等</span></p>
                                <p><span>[30,50)</span><span>六级二等</span></p>
                                <p><span>[12,30)</span><span>六级三等</span></p>
                                <p><span>[6,12)</span><span>七级一等</span></p>
                                <p><span>[1,6)</span><span>七级二等</span></p>
                                <p><span>[0,1)</span><span>七级三等</span></p>
                                <p><span>[-1,0)</span><span>八级一等</span></p>
                                <p><span>[-6,-1)</span><span>八级二等</span></p>
                                <p><span>[-12,-6)</span><span>八级三等</span></p>
                                <p><span>[-30,-12)</span><span>九级一等</span></p>
                                <p><span>[-50,-30)</span><span>九级二等</span></p>
                                <p><span>[-100,-50)</span><span>九级三等</span></p>
                                <p><span>[-200,-100)</span><span>十级一等</span></p>
                                <p><span>[-300,-200)</span><span>十级二等</span></p>
                                <p><span>[-500,-300)</span><span>十级三等</span></p>
                                <p><span>[-1000,-500)</span><span>十一级一等</span></p>
                                <p><span>[-2000,-1000)</span><span>十一级二等</span></p>
                                <p><span>[-4000,-2000)</span><span>十一级三等</span></p>
                                <p><span>[-6000,-4000)</span><span>十二级一等</span></p>
                                <p><span>[-8000,-6000)</span><span>十二级二等</span></p>
                                <p><span>[-10000,-8000)</span><span>十二级三等</span></p>
                                <p><span>[-15000,-10000)</span><span>十三级一等</span></p>
                                <p><span>[-30000,-15000)</span><span>十三级二等</span></p>
                                <p><span>[-50000,-30000)</span><span>十三级三等</span></p>
                                <p><span>[-80000,-50000)</span><span>十四级一等</span></p>
                                <p><span>[-15000,-80000)</span><span>十四级二等</span></p>
                                <p><span>&lt;150000</span><span>十四级三等</span></p>
                            </div>
                        </div> 
                        <div className='baseInfo'>
                            <table>
                                <tbody>
                                    {
                                        assetEvalInfo.ASSGRO!=undefined && assetEvalInfo.ASSGRO_RANK!=undefined ? 
                                        <tr>
                                            <td >资产总额</td>
                                            <td>{assetEvalInfo.ASSGRO_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.LIAGRO!=undefined && assetEvalInfo.LIAGRO_RANK!=undefined ? 
                                        <tr>
                                            <td >负债总额</td>
                                            <td>{assetEvalInfo.LIAGRO_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.VENDINC!=undefined && assetEvalInfo.VENDINC_RANK!=undefined ? 
                                        <tr>
                                            <td >营业总收入</td>
                                            <td>{assetEvalInfo.VENDINC_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.MAIBUSINC!=undefined && assetEvalInfo.MAIBUSINC_RANK!=undefined ? 
                                        <tr>
                                            <td >其中主营业务收入</td>
                                            <td>{assetEvalInfo.MAIBUSINC_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.RATGRO!=undefined && assetEvalInfo.RATGRO_RANK!=undefined ? 
                                        <tr>
                                            <td >纳税总额</td>
                                            <td>{assetEvalInfo.RATGRO_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.PROGRO!=undefined && assetEvalInfo.PROGRO_RANK!=undefined ? 
                                        <tr>
                                            <td >利润总额</td>
                                            <td>{assetEvalInfo.PROGRO_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.NETINC!=undefined && assetEvalInfo.NETINC_RANK!=undefined ? 
                                        <tr>
                                            <td >净利润</td>
                                            <td>{assetEvalInfo.NETINC_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                    {
                                        assetEvalInfo.TOTEQU!=undefined && assetEvalInfo.TOTEQU_RANK!=undefined ? 
                                        <tr>
                                            <td >所有者权益合计</td>
                                            <td>{assetEvalInfo.TOTEQU_RANK}</td>
                                        </tr>
                                        : 
                                        <></>
                                    }
                                </tbody>
                            </table>
                        </div>    
                    </div> */}

                    <div id="investorInfo" className="content-top">
                        <div className="table-more">
                            <WidgetInterfaceTable options={{
                                'url':url,
                                'records':5,
                                'title':'股东及出资信息'
                            }} columns={column1} params={{...params, ...{"service":"getInvestorInfo"}}} />
                        </div>
                    </div>
                    <div id="zyglry_id" className="content-top">
                        <div className="table-more">
                            <WidgetInterfaceTable options={{
                                'url':url,
                                'records':5,
                                'title':'主要管理人员'
                            }} columns={column2} params={{...params, ...{"service":"getManagerInfo"}}} />
                        </div>
                    </div>
                    <div id="gsbg_id" className="content-bottom">
                        <div className="table-more">
                            <WidgetInterfaceTable options={{
                                'url':url,
                                'records':5,
                                'title':'工商变更'
                            }} columns={column3} params={{...params, ...{"service":"getAlterInfo"}}} />
                        </div>
                    </div> 
                </div>
            </div>
        );
    }
}

export default Registration;
